<template>
  <v-dialog
    v-if="isTeamsEnabled"
    content-class="fixed-height-md"
    v-model="teamPickerShow"
    max-width="680px"
  >
    <modal-card
      title="Select Team"
      fixed
      padding
      @close="teamPickerShow = false"
    >
      <h4 class="appMain--text mb-2" v-if="sharing">
        Share {{ sharing.item.name }} to teams:
      </h4>
      <search-block
        v-model="selectedTeams"
        placeholder="Select teams"
        :options="teamsFormatted"
        :expandable="false"
        showSelected
        :multiple="!!sharing"
      />

      <template v-slot:actions>
        <v-btn v-if="sharing" color="appMain" @click="shareToTeams">
          Share
        </v-btn>
        <v-btn v-else color="appMain" @click="setTeam"> Save </v-btn>
      </template>
    </modal-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FEATURES } from '@/access/features';
import EventBus from '@/factories/eventBus';
import SearchBlock from '@/components/basic/search-block/SearchBlock';
import { teamBadgeIcon } from './teamIcon';

export default {
  name: 'TeamPicker',
  components: {
    SearchBlock,
  },
  data() {
    return {
      selectedTeams: [],
      teamPickerShow: false,
      sharing: null,
      resourcePath: {
        campaigns: 'campaigns',
        folders: 'lessons/folders',
      },
    };
  },
  computed: {
    ...mapGetters('users', ['currentUserLoaded']),
    ...mapGetters('teams', ['all', 'currentTeam', 'loaded']),
    teamsFormatted() {
      return this.all
        .map((i) => {
          return {
            label: i.label || '',
            value: i.id,
            color: i.color || 'var(--v-appMain-base)',
            badgeIcon: teamBadgeIcon(i),
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
    },
    isTeamsEnabled() {
      return this.isFeatureEnabled(FEATURES.TEAMS);
    },
  },
  watch: {
    currentUserLoaded: {
      immediate: true,
      handler(val) {
        if (!val) return;
        this.checkTeams();
      },
    },
  },
  methods: {
    ...mapActions('teams', ['load', 'updateResourceTeams', 'switchTeam']),

    checkTeams() {
      if (this.loaded) return;
      this.load();
    },

    shareToTeams() {
      let data = this.prepareData();

      if (data.add_teams.length || data.remove_teams.length) {
        this.updateResourceTeams({
          data,
          path: this.resourcePath[this.sharing.type],
          resourceId: this.sharing.item.id,
        }).then(() => {
          this.sharing.item.teams = data.full;
          this.closePicker();
        });
      }
    },

    setTeam() {
      return this.switchTeam({ teamId: this.selectedTeams || null });
    },

    closePicker() {
      this.teamPickerShow = false;
      this.selectedTeams = [];
      this.sharing = null;
    },

    prepareData() {
      let addedTeams = [];
      let removedTeams = [];
      let currentTeams = this.sharing.item.teams || [];

      if (currentTeams.length) {
        removedTeams = currentTeams.filter(
          (i) => !this.selectedTeams.includes(i)
        );
        addedTeams = this.selectedTeams.filter(
          (i) => !currentTeams.includes(i)
        );
      } else {
        addedTeams = this.selectedTeams;
      }

      return {
        add_teams: addedTeams,
        remove_teams: removedTeams,
        full: this.selectedTeams,
      };
    },
  },
  mounted() {
    EventBus.$on('showTeamPicker', ({ sharing }) => {
      if (sharing?.item) {
        this.sharing = sharing;
        this.selectedTeams = sharing.item.teams || [];
      } else {
        this.selectedTeams = this.currentTeam?.id;
      }
      this.teamPickerShow = true;
    });
  },
};
</script>
